import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import HeaderBread from "../../../components/HeaderBread";
import { useDataLayerValue } from "../../../DataLayer/DataLayer";
import Layout from "../../../Layout";

import { Box, Button, Card, CardContent } from "@mui/material";
import { message, Tag } from "antd";
import moment from "moment";
import Swal from "sweetalert2";
import CustomHeaderTitle from "../../../components/constants/CustomHeaderTitle";
import SwitchBar from "../../../components/Pages/SwitchBar";
import CustomizedData from "../../../components/UI/CustomizedData";
import { getVessels } from "../../../utils/ApiCalls/SpecialPage";
import { checkPermission } from "../../../utils/Validation/checkPermission";
import { getDailyPlannerData } from "../../../utils/ApiCalls/DailyPlanner";
import SailingToggle from "../../../components/SailingPage/SailingToggle";
import { getCurrentActiveSailing } from "../../../utils/ApiCalls/SailingData/index";
import Logs from "../../../components/Logs";

const DailyPlannerData = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [navigation, setNavigation] = useState([]);
  const [activePackage, setActicePackage] = useState({});

  const [rows, setRows] = useState([]);
  const [vesselOptions, setVesselOptions] = useState([]);
  const [status, setStatus] = useState("all");
  const [vessel, setVessel] = useState();
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [{ permission }, dispatch] = useDataLayerValue();

  useEffect(() => {
    if (vessel) getData(page);
  }, [page, pageSize, vessel, status]);
  useEffect(() => {
    setNavigation([
      {
        title: "Home",
        route: "/",
      },
      {
        title: vessel?.name,
        route: "/website/cms/daily-planner",
      },
    ]);
  }, [vessel]);

  useEffect(() => {
    if (params?.vessel) {
      getOptionLocation();
    }
  }, [params]);
  const getOptionLocation = async () => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });

    let vessels = await getVessels();

    if (vessels.error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: vessels.error,
      });
    } else {
      setVessel(
        vessels.find(
          (item) =>
            item.name.toLowerCase().replaceAll(" ", "-") == params?.vessel
        )
      );
      setVesselOptions(vessels);
    }
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };
  const getData = async (value) => {
    let dataQuery = {
      page: value,
      limit: pageSize,
      vessel_id: vessel.id,
    };

    if (status != "all") {
      dataQuery.status = status;
    } else {
      delete dataQuery?.status;
    }
    let data = await getDailyPlannerData(dataQuery);
    let activeSailingData = await getCurrentActiveSailing(vessel.id);
    if (data.error)
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: data.error, type: "error" },
      });
    else if (data.data) {
      setRows(data.data);
      setCount(data.count);
      setActicePackage(activeSailingData);
    }
  };
  const handleEdit = async (id) => {
    if (
      checkPermission(
        permission,
        "update_per",
        vessel?.name,
        window?.location?.pathname
      )
    ) {
      navigate(`/shore/daily-planner/${params.vessel}/edit/` + id);
    } else {
      message.error("Update permission missing");
    }
  };
  const handleDuplicate = async (id) => {
    if (
      checkPermission(
        permission,
        "update_per",
        vessel?.name,
        window?.location?.pathname
      )
    ) {
      navigate(`/shore/daily-planner/${params.vessel}/duplicate/` + id);
    } else {
      message.error("Update permission missing");
    }
  };

  return (
    <Layout type={"read_per"} module_data={vessel?.name}>
      <CustomHeaderTitle title={vessel?.name} />
      <div>
        <div>
          <HeaderBread
            navigation={navigation}
            title={vessel?.name}
          ></HeaderBread>
        </div>
        <section className="content" style={{ marginTop: "20px" }}>
          <div className="container-fluid">
            <div className="card">
              <div className="card-header two_item">
                <h5 className="card-title">{vessel?.name} List</h5>
                <div className="two_item">
                  <Link
                    to={`/shore/daily-planner/${params.vessel}/add`}
                    className="btn add_v_btn mx-2"
                  >
                    Add Planner
                  </Link>
                </div>
              </div>
              <div className="card-body">
                <SwitchBar
                  tabs={[
                    { title: "All", value: "all" },
                    { title: "Active Planner", value: "Active" },
                    // { title: "Upcomming Planner", value: "upcomming" },
                    { title: "Completed Planner", value: "Completed" },
                    { title: "Draft Planner", value: "Draft" },
                    { title: "History Logs", value: "logs" },
                  ]}
                  activeTab={status}
                  setActiveTab={setStatus}
                />
                {status !== "logs" && (
                  <div className="table_holder">
                  <CustomizedData
                    setRows={setRows}
                    setPageSize={setPageSize}
                    setPage={setPage}
                    render={(page, index) => (
                      <Card
                        key={page.id}
                        variant="outlined"
                        sx={{ mb: 2, border: "1px solid black" }}
                      >
                        <CardContent
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            p: 1,
                          }}
                        >
                          <Box>
                            <Box
                              sx={{
                                display: "flex",
                                width: "100%",
                                alignItems: "flex-start",
                                gap: "10px",
                              }}
                            >
                              <Box>
                                <h5 style={{ fontWeight: "bold" }}>
                                  {moment(page?.sailing_date).format("DD MMM")} to {moment(page?.sailing_date).add(page?.duration || 0, 'days').format("DD MMM YYYY")} /
                                  {" " + page?.duration} Nights
                                </h5>

                                <h6>{page?.page_count || 0} Page Assigned</h6>
                              </Box>
                              {/* Computed Status */}
                              <Tag
                                color={
                                  page?.status?.toLowerCase() === "active"
                                    ? "green"
                                    : page?.status?.toLowerCase() === "upcoming"
                                    ? "blue"
                                    : page?.status?.toLowerCase() === "completed"
                                    ? "red"
                                    : "default"
                                }
                              >
                                {page?.status
                                  ? page.status.charAt(0).toUpperCase() +
                                    page.status.slice(1)
                                  : ""}
                              </Tag>
                            </Box>
                            <Box
                              sx={{
                                display: "flex",
                                gap: "10px",
                                marginTop: "10px",
                              }}
                            >
                              {(page.status == "Draft" ||
                                page.status == "Active") && (
                                <Button
                                  variant="contained"
                                  className=""
                                  onClick={() => handleEdit(page.id)}
                                >
                                  Manage Planner Content
                                </Button>
                              )}
                              {page?.showDuplicate && (
                                <Button
                                  variant="contained"
                                  onClick={() => handleDuplicate(page.id)}
                                >
                                  Duplicate Planner
                                </Button>
                              )}
                            </Box>
                          </Box>
                          <SailingToggle
                            data={page}
                            activeSailing={activePackage}
                            setActiveSailing={setActicePackage}
                            isEditable={false}
                            enableDelete={page.enableDelete}
                            getData= {getData}
                            page_count={page.page_count || 0}
                          />
                        </CardContent>
                      </Card>
                    )}
                    pageSize={pageSize}
                    page={page}
                    count={count}
                    columns={[]}
                    rows={rows}
                    title={vessel?.name}
                  />
                </div>
                )}
              </div>
            </div>
            {status === "logs" && (
              <Logs
                type={"Daily Planner"}
                slug={`/shore/daily-planner/${params.vessel}/edit/`}
              />
            )}
          </div>
        </section>
      </div>
    </Layout>
  );
};

export default DailyPlannerData;
